import { OrderedAsyncEnumerable } from "../OrderedAsyncEnumerable.js";
export const orderByDescendingAsync = (source, keySelector, comparer) => {
    return OrderedAsyncEnumerable.generateAsync(source, keySelector, false, comparer);
};
